// extracted by mini-css-extract-plugin
module.exports = {"link":"DonationRecord_link_2p1C7"};